import { httpClient } from '@/shared/api/httpClient';

export type EstoqueResumo = {
  produtoId: string;
  codigo: string;
  nome: string;
  ativo: boolean;
  quantidade: number;
};

export type TipoMovimentacaoEstoque = 'Entrada' | 'Saida';

export type MovimentacaoEstoqueResumo = {
  id: string;
  produtoId: string;
  produtoCodigo: string;
  produtoNome: string;
  tipo: TipoMovimentacaoEstoque;
  quantidade: number;
  saldoAntes: number;
  saldoDepois: number;
  motivo: string;
  origemTipo: 'Produto' | 'Orcamento' | 'Estoque' | 'EstornoOrcamento';
  origemId: string | null;
  estornada: boolean;
  criadoEm: string;
  /** true para movimentações manuais ainda não confirmadas pelo servidor. */
  syncPendente: boolean;
};

export type MovimentarEstoqueRequest = {
  quantidade: number;
  motivo: string;
};

export const estoqueApi = {
  listar: () => httpClient.get<EstoqueResumo[]>('/api/estoque'),
  listarMovimentacoes: (produtoId?: string) => {
    const query = produtoId ? `?produtoId=${encodeURIComponent(produtoId)}` : '';
    return httpClient.get<MovimentacaoEstoqueResumo[]>(`/api/estoque/movimentacoes${query}`);
  },
  adicionar: (produtoId: string, cmd: MovimentarEstoqueRequest) =>
    httpClient.post<void>(`/api/estoque/${produtoId}/entrada`, cmd),
  remover: (produtoId: string, cmd: MovimentarEstoqueRequest) =>
    httpClient.post<void>(`/api/estoque/${produtoId}/saida`, cmd),
};
